import React from "react";

function About() {
  return (
    <section id="about">
      <div className="md:px-40  my-20" >
        <h1 className="custom-h1 hr">About Us</h1>
        <hr className="border-t border-gray-300 my-4" />
        <p className="text-xl p-2 text-sky-100 text-center font-poppins">
          Welcome to <strong>MagnateForex</strong>, a modern <strong>forex</strong> and <strong>binary</strong> options company proudly headquartered in Nairobi, Kenya, and a proud branch of the globally recognized <strong> <span ><code>Magnate Empire</code></span>.</strong> We specialize in empowering traders with cutting-edge tools and reliable guidance to succeed in today’s fast-paced financial markets. Whether you're a beginner or a seasoned investor, our intelligent trading guide provides step-by-step strategies to help you trade smarter and with confidence. Our online store features a curated selection of <strong>affordable, high-performance trading bots </strong>designed to automate success and boost your profits. At MagnateForex, we are committed to transparency, innovation, and financial freedom for all. Join thousands of traders who trust us to simplify trading and transform their financial future.
        </p>
      </div>
    </section>
  );
}

export default About;
